import React from "react";
import { Autocomplete, Box, Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, FormControl, InputLabel, MenuItem, Select, Slide, TextField } from "@mui/material";
import { TransitionProps } from "notistack";

import FilterDispatch, { CustomFilterState } from "./model";
const Transition = React.forwardRef(function Transition(
    props: TransitionProps & {
        children: React.ReactElement;
    },
    ref: React.Ref<unknown>,
) {
    return <Slide direction="up" ref={ref} {...props} />;
});


class Filter extends React.PureComponent<{}>{


    render() {
        let dispatcher: FilterDispatch = (this.props as any).dispatcher
        let state: CustomFilterState = (this.props as any).state
        return (

            <Dialog
                open={state.filter.isOpen}
                dir="rtl"
                TransitionComponent={Transition} >
                <DialogTitle>جستجو</DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        <Box sx={{ width: '50vh' }} />
                    </DialogContentText>
                    <TextField
                        autoFocus
                        margin="dense"
                        id="search"
                        label="جستجو"
                        type="text"
                        fullWidth
                        value={state.filter.filter.address}
                        variant="outlined"
                        onChange={(e) => {
                            dispatcher.address(e.target.value)
                        }}
                    />

                    <FormControl fullWidth sx={{ mt: 2 }}>
                        <InputLabel id="demo-simple-select-label">نوع فایل</InputLabel>
                        <Select
                            labelId="demo-simple-select-label"
                            id="demo-simple-select"
                            value={state.filter.filter.fileTypeId}
                            label="نوع فایل"
                            onChange={(e) => {
                                dispatcher.type(+e.target.value)
                            }}>
                            <MenuItem key='types-0' value={0}>همه</MenuItem>
                            {state.home.types.map((val, inx, arr) => {
                                return (<MenuItem key={val.title} value={val.id}>{val.title}</MenuItem>)
                            })}
                        </Select>
                    </FormControl>

                    {
                        state.filter.filter.fileTypeId !== 0 && <Box sx={{ flexDirection: 'column', width: '100%' }} display='flex'>
                            {
                                state.home.properties.filter((vv, ii, aa) => {
                                    return vv.fileTypeId === state.filter.filter.fileTypeId
                                }).map((prop, inxx, arrr) => {
                                    let index = state.filter.filter.propertyValueList.findIndex((vp, ip, aa) => {
                                        return vp.propertyId === prop.id
                                    })
                                    return (
                                        <Box key={prop.title} sx={{ flexDirection: 'row', width: '100%' }} display='flex'>
                                            <TextField
                                                autoFocus
                                                margin="dense"
                                                label={prop.title}
                                                value={index !== -1 ? state.filter.filter.propertyValueList[index].propertyValue1?.replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,') : undefined}
                                                placeholder="از"
                                                type="text"
                                                variant="outlined"
                                                sx={{ ml: 0.25 }}
                                                onChange={(e) => {
                                                    dispatcher.props(prop.id, e.target.value.replaceAll(',', ''), true)
                                                }}
                                            />
                                            <TextField
                                                autoFocus
                                                margin="dense"
                                                label={prop.title}
                                                value={index !== -1 ? state.filter.filter.propertyValueList[index].propertyValue2?.replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,') : undefined}
                                                placeholder="تا"
                                                type="text"
                                                variant="outlined"
                                                sx={{ mr: 0.25 }}
                                                onChange={(e) => {
                                                    dispatcher.props(prop.id, e.target.value.replaceAll(',', ''), false)
                                                }}
                                            />

                                        </Box>

                                    )
                                })
                            }
                        </Box>
                    }

                    <Autocomplete
                        multiple
                        id="grouped-demo"
                        options={state.home.tags}
                        getOptionLabel={(option) => option.tag}
                        onChange={(e, value, reason, detail) => {
                            dispatcher.tags(value.map((t, i, a) => {
                                return t.id
                            }))
                        }}
                        value={state.home.tags.filter((t, ii, aa) => {
                            return state.filter.filter.tags.includes(t.id)
                        })}
                        noOptionsText='کلمه کلیدی یافت نشد'
                        fullWidth
                        sx={{ mt: 2 }}
                        dir="ltr"
                        renderInput={(params) => <TextField {...params} label="کلمات کلیدی" />}
                    />
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => {
                        dispatcher.reset()
                        dispatcher.filter({
                            address: '',
                            fileTypeId: 0,
                            propertyValueList: [],
                            tags: []
                        })

                    }} color="error">پاک شود</Button>
                    <Button onClick={() => {
                        dispatcher.filter(state.filter.filter)
                        dispatcher.open(false)
                    }} color="success">فیلترشود</Button>
                </DialogActions>
            </Dialog>
        )
    }

}

export default Filter

